import { MultiFlightPathCanvasXAltitudeGrid as MultiFlightPathCanvasXAltitudeGridComponent } from "heat-next";

import { useSessionDetailsContext } from "@/context/session-details/session-details";

import { ComponentWrapper } from "@/pages/shared/shared.styles";

import ContentLoader from "@/components/content-loader/content-loader";
import EmptyState from "@/components/empty-state/empty-state";
import { EmptyStateType } from "@/components/empty-state/empty-state.types";

import type { MultiFlightPathCanvasXAltitudeGridData } from "./types/multi-flight-path-canvas-x-altitude-grid.types";

interface MultiFlightPathCanvasXEyeTrackingCanvasProps {
    isInsideModal?: boolean;
    subDimensionsData?: any;
}

const MultiFlightPathCanvasXAltitudeGrid = ({
    isInsideModal,
    subDimensionsData,
}: MultiFlightPathCanvasXEyeTrackingCanvasProps) => {
    const { multiFlightCircuitData, isFetchingMultiFlightCircuit, isErrorMultiFlightCircuit } =
        useSessionDetailsContext();

    const flightCircuit = isInsideModal
        ? subDimensionsData?.flat().filter((item: any) => item?.chartType === "MultiFlightPath")
        : multiFlightCircuitData;

    //fetch altitudeData per Intercept
    const getAltitudeGridData = () => {
        const flightData = {
            data: {
                altitudes: [],
                canvasWidth: 288,
                canvasHeight: 288,
                defaultAltitudeText: 0,
                measurementUnit: "ft",
                textLabel: "Altitude Difference",
            },
        };

        return flightData;
    };

    //fetch flightPathData per Intercept
    const getFlightPathData = (flightPath: any) => {
        const flightData = {
            canvasHeight: 288,
            canvasWidth: 720,
            fitAllPathsToPlot: false,
            textLabel: "Aircraft Range",
            textNumber: "0",
            topDownView: true,
            pathsData: flightPath?.pathsData,
        };

        return flightData;
    };

    //Prepare data for MultiFlightPathCanvasXAltitudeGrid component per circuit
    const multiFlightPathCanvasXAltitudeGridData = flightCircuit?.map((flightPath: any) => {
        return {
            title: flightPath?.id,
            flightPathCanvasData: getFlightPathData(flightPath),
            altitudeFlightPathData: getAltitudeGridData(),
        };
    });

    const isFlightCircuitDataEmptyState =
        !isErrorMultiFlightCircuit &&
        (!multiFlightPathCanvasXAltitudeGridData ||
            multiFlightPathCanvasXAltitudeGridData?.every(
                (flightPath: MultiFlightPathCanvasXAltitudeGridData) => {
                    return flightPath?.flightPathCanvasData?.pathsData?.length === 0;
                },
            ));

    const isEmptyState = () => {
        if (isInsideModal) {
            return subDimensionsData?.every((v: any) => v === undefined);
        } else if (isFlightCircuitDataEmptyState) {
            return true;
        }
    };

    if (isFetchingMultiFlightCircuit) {
        return <ContentLoader height="28.875rem" />;
    }

    if (!isInsideModal && isErrorMultiFlightCircuit && !isFetchingMultiFlightCircuit) {
        return (
            <ComponentWrapper>
                <EmptyState
                    title="error-state:title"
                    emptyStateType={EmptyStateType.Error}
                    minHeight="25.875rem"
                />
            </ComponentWrapper>
        );
    }

    if (isEmptyState()) {
        return (
            <ComponentWrapper>
                <EmptyState
                    title="session-detail:no-altitude-data"
                    emptyStateType={EmptyStateType.Charts}
                    minHeight="25.875rem"
                />
            </ComponentWrapper>
        );
    }

    if (isFetchingMultiFlightCircuit) {
        return <ContentLoader height={"26.4375rem"} />;
    }

    return (
        <MultiFlightPathCanvasXAltitudeGridComponent
            dualPlaybackProps={{
                rowGap: "0.5rem",
                leftPercent: 66,
            }}
            isInsideModal={isInsideModal}
            data={multiFlightPathCanvasXAltitudeGridData}
        />
    );
};

export default MultiFlightPathCanvasXAltitudeGrid;
